import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { canAccessPage } from "../utils/pageAccess";

interface PageVisibilityRouteProps {
  pageId: string;
  children: React.ReactNode;
}

const PageVisibilityRoute: React.FC<PageVisibilityRouteProps> = ({
  pageId,
  children,
}) => {
  const { isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center" role="status" aria-label="Loading page access">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-t-2 border-blue-500"></div>
      </div>
    );
  }

  if (!canAccessPage(pageId, user)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PageVisibilityRoute;
